import Axios from 'axios';

interface Params {
  token: string;
  url: string;
}
export interface UsuarioAura<T> {
  dados: T;
  perfil: 'ALUNO' | 'EDUCADOR';
}

export const consultaPerfilUsuarioPorTokenService = async <T>({ token, url }: Params): Promise<UsuarioAura<T>> => {
  const authorization = `Bearer ${token}`;

  const { data, headers } = await Axios.get<T>(url, {
    headers: { authorization },
  });
  return {
    dados: data,
    perfil: headers['x-perfil'] as 'ALUNO' | 'EDUCADOR',
  };
};
